import { DateTime } from 'luxon'
import { formatPhoneNumber } from 'react-phone-number-input'

import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { Card, CardColors, Heading, HeadingVariants, Text } from '@/ui'
import { TypographyStyles } from '@/styles'
import { EditSmsConsentDialog } from '@/features/user/settings/sections/account-details-card/sms-consent/EditConsentDialog'

interface OptedInProps {
  createdAt: string
  mobilePhoneNumber?: string | null
}

export const OptedIn = ({ createdAt, mobilePhoneNumber }: OptedInProps) => {
  const getOptInDate = () => {
    if (!createdAt) return 'Update your SMS consent status'

    const optInDate = DateTime.fromISO(createdAt || '').toFormat(
      DATE_FORMATS_LUXON.DISPLAY_LONG
    )

    return `You opted into receiving notifications on ${optInDate}.`
  }

  return (
    <Card color={CardColors.LEVEL_1} childrenClassName="flex flex-row gap-4">
      <div className="flex-grow">
        <Heading variant={HeadingVariants.H3}>Permissions</Heading>

        <div className="flex items-center justify-between gap-2">
          <Text>{getOptInDate()}</Text>
        </div>

        <Heading variant={HeadingVariants.H3} className="mt-2">
          Your Mobile Number
        </Heading>

        {mobilePhoneNumber && (
          <Text variant={TypographyStyles.H3}>
            {formatPhoneNumber(mobilePhoneNumber)}
          </Text>
        )}
      </div>
      <div>
        <EditSmsConsentDialog />
      </div>
    </Card>
  )
}
